/** Evita banner doppi sullo STESSO messageId (socket + push), non tra messaggi diversi. */
const recent = new Map<string, number>()
const NOTIFY_DEDUP_MS = 8_000
const PUSH_DEDUP_CACHE = 'zion-push-dedup'

export function notifyDedupKey(parts: { messageId?: string }): string {
  const messageId = String(parts.messageId || '').trim()
  if (messageId) return `id:${messageId}`
  // Senza messageId: mai dedupare — ogni messaggio deve poter suonare
  return `unique:${Date.now()}:${Math.random().toString(36).slice(2, 10)}`
}

function cacheKeyFromDedupKey(key: string): string {
  if (!key.startsWith('id:')) return ''
  return `id_${key.slice(3)}`
}

function dedupCacheUrl(cacheKey: string): string {
  const origin =
    typeof location !== 'undefined' && location.origin ? location.origin : 'https://www.zionyx.ch'
  const safe = encodeURIComponent(String(cacheKey).slice(0, 180))
  return `${origin}/app/__zion_push_dedup/${safe}`
}

function markRecent(key: string): void {
  const now = Date.now()
  recent.set(key, now)
  for (const [k, t] of recent) {
    if (now - t > NOTIFY_DEDUP_MS) recent.delete(k)
  }
}

/** Dedup in-memory: solo stesso messageId reale. */
export function shouldSkipDuplicateNotify(key: string): boolean {
  const cacheKey = cacheKeyFromDedupKey(key)
  if (!cacheKey) return false
  const now = Date.now()
  const last = recent.get(key)
  if (last != null && now - last < NOTIFY_DEDUP_MS) return true
  markRecent(key)
  return false
}

/** Dedup condiviso col service worker: solo stesso messageId. */
export async function shouldSkipDuplicateNotifyShared(key: string): Promise<boolean> {
  const cacheKey = cacheKeyFromDedupKey(key)
  if (!cacheKey) return false
  if (shouldSkipDuplicateNotify(key)) return true
  if (typeof caches === 'undefined') return false

  try {
    const cache = await caches.open(PUSH_DEDUP_CACHE)
    const req = dedupCacheUrl(cacheKey)
    const match = await cache.match(req)
    if (match) {
      try {
        const parsed = (await match.json()) as { t?: number }
        const t = Number(parsed?.t) || 0
        if (t && Date.now() - t < NOTIFY_DEDUP_MS) return true
      } catch {
        return true
      }
    }
    await cache.put(
      req,
      new Response(JSON.stringify({ t: Date.now() }), {
        headers: { 'Content-Type': 'application/json' },
      }),
    )
    markRecent(key)
    setTimeout(() => {
      void cache.delete(req)
    }, NOTIFY_DEDUP_MS)
    return false
  } catch {
    return false
  }
}
